import type { ArtifactResponse } from '@/client/types.gen'

const LABEL_KEYS: Record<string, string> = {
	as_is: 'pages.projectDetail.modal.labels.asIs',
	to_be: 'pages.projectDetail.modal.labels.toBe',
	other: 'pages.projectDetail.modal.labels.other',
	process_description: 'pages.projectDetail.modal.labels.processDescription',
	process_interview: 'pages.projectDetail.modal.labels.processInterview',
	process_mining_report: 'pages.projectDetail.modal.labels.processMiningReport',
	system_technical: 'pages.projectDetail.modal.labels.systemTechnical',
	reference_framework: 'pages.projectDetail.modal.labels.referenceFramework',
	norm_standard: 'pages.projectDetail.modal.labels.normStandard',
	background_source: 'pages.projectDetail.modal.labels.backgroundSource',
	// Legacy-only purpose: still present on some rows / DB enum, not offered in the selector.
	normative_standard: 'pages.projectDetail.modal.labels.normativeStandard',
	additional_source: 'pages.projectDetail.modal.labels.additionalSource',
	other_custom: 'pages.projectDetail.modal.labels.otherCustom',
}

export function getLabelDisplay(
	value: string | null | undefined,
	t: (key: string) => string
): string {
	if (!value?.trim()) return '—'
	const key = LABEL_KEYS[value]
	return key ? (t(key) as string) : value
}

export function getLabelDisplayOrNull(
	value: string | null | undefined,
	t: (key: string) => string
): string | null {
	if (!value?.trim()) return null
	const key = LABEL_KEYS[value]
	return key ? (t(key) as string) : value
}

export function formatArtifactLabel(artifact: ArtifactResponse, t: (k: string) => string): string {
	const parts: string[] = []
	if (artifact.time_dimension) {
		parts.push(getLabelDisplay(artifact.time_dimension, t))
	}
	if (artifact.purpose) {
		parts.push(
			artifact.purpose === 'other_custom' && artifact.purpose_custom
				? artifact.purpose_custom
				: (getLabelDisplay(artifact.purpose, t) as string)
		)
	}
	return parts.join(' · ')
}
